<template>
	<div>
		<!-- Mapping Summary Start -->
		<div class="shadow rounded p-10">
			<div class="row">
				<div class="col-12 mt-1 col-md-5 Aligner-Header">
					<h3>Mapping Summary</h3>
				</div>
				<div class="col-12 mt-1 offset-md-1  col-md-2">
					<Multiselect
						class="w-100"
						:options="['Semester' , 'Quarterly', 'Monthly']"
						:searchable="true"
						:close-on-select="true"
						:show-labels="false"
						v-model="optionRangeMapping"
					/>
				</div>
				<div class="col-12 mt-1 col-md-4" style="padding-left:0">
					<div class="form-group">
						<date-range-picker 
							class="w-100 mr-4"
							v-model="mappingRange"
							style="min-height:43px"
							ref="picker"
							:opens="'left'"
							:ranges="rangeOption[optionRangeMapping]"
							:locale-data="{ firstDay: 1, format: 'MMM DD, YYYY' }"
						>
							<template v-slot:input="picker" style="min-width: 350px;" class="text-center">
								<i class="fa fa-calendar fa-fw ml-n1"></i> 
								{{labelMapping == '' ? '' : labelMapping + ' -'}} {{ moment(picker.startDate).format("DD MMMM YYYY")}} - {{ moment(picker.endDate).format("DD MMMM YYYY")}}
								<b class="caret"></b>
							</template>
						</date-range-picker>
					</div>
				</div>
			</div>
				<div class="content-outer">
				<div class="content-inner" style="padding: 2%;">
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 stats-outer-box">
							<div class="stats-inner-box" style="background-color: #F59C19;">
								<div class="row" style="height: 100%">
									<div class="col-8">
									<p>Total Mapping Overall</p>
									<p class="stats-value" v-if="data.mappingTotal">
										{{numberWithCommas(data.mappingTotal.total)}}
									</p>
									<p class="stats-value" v-else>
										Loading.....
										<!-- <span class="stats-value-support">(4,5)</span> -->
									</p>
									</div>
									<div class="col-4 icon">
									<i class="fas fa-qrcode"></i>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 stats-outer-box">
							<div class="stats-inner-box" style="background-color:#DC143C">
								<div class="row" style="height: 100%">
									<div class="col-8">
									<p>Total Mapping H1</p>
									<p class="stats-value" v-if="data.mappingTotal">
										{{numberWithCommas(data.mappingTotal.total_h1)}}
										<!-- <span class="stats-value-support">(4,5)</span> -->
									</p>
									<p class="stats-value" v-else>
										Loading.....
										<!-- <span class="stats-value-support">(4,5)</span> -->
									</p>
									</div>
									<div class="col-4 icon">
									<i class="fas fa-qrcode"></i>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 stats-outer-box">
							<div class="stats-inner-box" style="background-color: #BA55D3;">
								<div class="row" style="height: 100%">
									<div class="col-8">
									<p>Total Mapping H2</p>
									<p class="stats-value" v-if="data.mappingTotal">
										{{numberWithCommas(data.mappingTotal.total_h2)}}
										<!-- <span class="stats-value-support">(4,5)</span> -->
									</p>
									<p class="stats-value" v-else>
										Loading.....
										<!-- <span class="stats-value-support">(4,5)</span> -->
									</p>
									</div>
									<div class="col-4 icon">
									<i class="fas fa-qrcode"></i>
									</div>
								</div>
							</div>
						</div>
					</div>
					<p style="font-weight: bold; font-size: large;">H1</p>
					<mapping-summary-chart :data="data.mappingH1" :type="'H1'" v-if="data.mappingH1"
					></mapping-summary-chart>
					<div v-else style="text-align:center; margin-top:20px"><h4>Loading...</h4></div>
					<p style="font-weight: bold; font-size: large;">H2</p>
					<mapping-summary-chart :data="data.mappingH2" :type="'H2'" v-if="data.mappingH2"
					></mapping-summary-chart>
					<div v-else style="text-align:center; margin-top:20px"><h4>Loading...</h4></div>
				</div>
			</div>
		</div>
		<!-- Mapping Summary End -->
	</div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import mappingSummaryChart from './../children/mappingSummaryChart.vue'
  import listUrl from './../listUrl.js'
import DateRangePicker from 'vue2-daterange-picker'
  import moment from 'moment'

export default {
	props: ['options' , 'period', 'mobile', 'data' ,'rangeOption', 'filter'],
	components: {
		Multiselect,
		mappingSummaryChart,
		DateRangePicker
	},
	data () {
		return {
			optionRangeMapping : 'Semester',
			mappingRange : {
				startDate : this.filter.mappingSummary.start,
				endDate : this.filter.mappingSummary.end,
			},
			labelMapping : '',
			moment : moment
		}
	},
	mounted () {
		this.$emit('search')
	},
	watch : {
		mappingRange : function() {
			this.filter.mappingSummary.start = new moment(this.mappingRange.startDate).format('Y-MM-DD')
			this.filter.mappingSummary.end = new moment(this.mappingRange.endDate).format('Y-MM-DD') + " 23:59:59"

			let start =  new moment(this.mappingRange.startDate).format("Y-MM-DD").split('-')
			if(this.optionRangeMapping == 'Semester')
				this.labelMapping = parseInt(start[1]) > 6 ? `S2 ${start[0]}` : `S1 ${start[0]}`
			else if(this.optionRangeMapping == 'Quarterly')
				this.labelMapping = parseInt(start[1]) < 4 ? `Q1 ${start[0]}` : parseInt(start[1]) < 7 ? `Q2 ${start[0]}` : parseInt(start[1]) < 10 ? `Q3 ${start[0]}` : `Q4 ${start[0]}`
			else 
				this.labelMapping = `Custom`

			let url = listUrl.stringUrl.mappingSummary.mappingSummary
			let params = listUrl.param.mappingSummary.mappingSummary

			this.$emit('loadAPI' , url , params )
			console.log("emited")
		}
	},
	methods: {
		numberWithCommas(x) {
            return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
	}
}
</script>